<template>
	<div class="main">
		<header class="page-title">
			<h2>Charts</h2>
			<div class="ml-auto">
				<a @click="showHelpModal" class="btn btn-md btn-primary" href="#"><i class="fas fa-question-circle"></i> Help</a>
				<a @click="showNewModal" class="btn btn-md btn-success" href="#"><i class="fas fa-plus"></i> New Chart</a>
			</div>
		</header>
		<div class="table-responsive">
			<table>
				<thead>
					<tr>
						<th>Name</th>
						<th>Item Count</th>
						<th>Shortcode</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in charts">
						<td>{{ item.name }}</td>
						<td>{{ item.counter }}</td>

						<td>
							<code class="inline-block">[[post-object type="charts" name="{{ item.name }}" chart="bar" /]]</code>
						</td>
						<td class="nowrap">
							<a @click="showPreviewModal(item.name,item.id)" class="btn btn-icon btn-primary" href="#" title="Preview"><i class="fas fa-chart-bar"></i></a>
							<a @click="showEditModal(item.name,item.id)" class="btn btn-icon btn-primary" href="#" title="Edit"><i class="fas fa-pencil-alt"></i></a>
							<a @click="deleteTable(item.id)" class="btn btn-icon btn-danger" href="#" title="Delete"><i class="fas fa-trash"></i></a>
						</td>

					</tr>
				</tbody>
			</table>
		</div>

		<modal :modal-name="'newModal'">
			<template #modal-header>
				<h4 class="modal-title">New Data Table</h4>
			</template>
			<template #modal-body>
				<div class="form-group">
					<label for="new-name">Name</label>
					<input id="new-name" type="text"/>
				</div>
				<div class="form-group">
					<label for="new-file">File</label>
					<input id="new-file" ref="file" type="file" v-on:change="handleFileUpload()"/>
				</div>
			</template>
			<template #modal-footer>
				<a @click="submitFile" class="btn btn-md btn-success" href="#"><i class="fas fa-check"></i> Add Data Table</a>
			</template>
		</modal>

		<modal :modal-name="'editModal'">
			<template #modal-header>
				<h4 class="modal-title">Edit Chart</h4>
			</template>
			<template #modal-body>
				<div class="form-group">
					<label for="edit-name">Name</label>
					<input id="edit-name" type="text" v-model="customname">
				</div>
				<div class="form-group">
					<label for="edit-file">File</label>
					<input id="edit-file" ref="newfile" type="file" v-on:change="handleNewFileUpload()"/>
				</div>
			</template>
			<template #modal-footer>
				<a @click="editChart" class="btn btn-md btn-success" href="#"><i class="fas fa-save"></i> Save Changes</a>
			</template>
		</modal>

		<modal :modal-name="'previewModal'">
			<template #modal-header>
				<h4 class="modal-title">Preview Chart</h4>
			</template>
			<template #modal-body>
				<div class="chart-previews flex box start">
					<div class="six-lg">
						<h4 class="mt-0">Graph <code class="inline">chart="line"</code></h4>
						<canvas ref="graph" id="graph"></canvas>
					</div>
					<div class="six-lg">
						<h4 class="mt-0">Bar <code class="inline">chart="bar"</code></h4>
						<canvas ref="bar" id="bar"></canvas>
					</div>
					<div class="six-lg">
						<h4>Horizontal Bar <code class="inline">chart="horizontalBar"</code></h4>
						<canvas ref="hbar" id="hbar"></canvas>
					</div>
					<div class="six-lg">
						<h4>Pie <code class="inline">chart="pie"</code></h4>
						<canvas ref="pie" id="pie"></canvas>
					</div>
				</div>
			</template>
		</modal>

		<modal :modal-name="'helpModal'">
			<template #modal-header>
				<h4 class="modal-title">Help</h4>
			</template>
			<template #modal-body>
				<h4 class="mt-0">How to Use</h4>
				<div class="table-responsive">
					<table>
						<thead>
							<tr>
								<th>Parameter</th>
								<th colspan="2">Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td class="nowrap"><code class="inline-block">name</code>
									<span class="text-danger">*</span></td>
								<td colspan="2">The name of the Chart.</td>
							</tr>
							<tr>
								<td class="nowrap"><code class="inline-block">chart</code>
									<span class="text-danger">*</span></td>
								<td colspan="2">The type of the chart, can be: "line","bar","horizontalBar", "pie". Click the preview button for live previews.
									<br>This value is case sensitive.
								</td>
							</tr>
							<tr>
								<td class="nowrap"><code class="inline-block">Source file</code></td>
								<td>Upload any csv file that contains the rows and columns for generating the chart, the easiest way is to generate it in Excel.
									<br>Important: The first row must be called: "labels", this will be used to generate the labels for the charts.
								</td>
								<td>
									Sample:
									<img src="/images/charts.jpg">
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</template>
		</modal>
	</div>
</template>

<script>
import Modal from "../Modal/Modal";
import {eventBus} from "../../app";

export default {
	props: {
		dataCharts: {
			type: Object
		}
	},
	components: {
		Modal
	},
	mounted() {
		let chartScript = document.createElement('script');
		chartScript.setAttribute('src', location.protocol + '//' + location.hostname + '/2019/js/chart.js');
		document.head.appendChild(chartScript);
	},
	data() {
		return {
			charts: this.dataCharts,
			customname: 'new',
			currentId: 0,
			isHelpModalVisible:
					false,
		}
	},
	methods: {
		showNewModal: function () {
			eventBus.$emit('onModalOpen_newModal');
		},
		showEditModal: function (customname, id) {
			this.customname = customname;
			this.currentId = id;
			eventBus.$emit('onModalOpen_editModal');
		},
		showPreviewModal: function (customname, id) {
			let vm = this;
			vm.customname = customname;
			vm.currentId = id;
			eventBus.$emit('onModalOpen_previewModal');
			vm.$nextTick(function () {
				vm.generateChart(id);
			})
		},
		showHelpModal: function () {
			eventBus.$emit('onModalOpen_helpModal');
		},
		handleFileUpload() {
			this.file = this.$refs.file.files[0];
		},
		handleNewFileUpload() {
			this.newfile = this.$refs.newfile.files[0];
		},
		submitFile() {
			let formData = new FormData();

			formData.append('name', document.querySelector("input[id=customname]").value);
			formData.append('csv', this.file);

			axios.post(window.location.pathname,
					formData,
					{
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					}
			).then(function () {
				location.reload();
			}).catch(function () {});
		},
		editChart() {
			let formData = new FormData();
			formData.append('id', this.currentId);
			formData.append('_method', 'PUT');
			formData.append('name', document.querySelector("input[id=edit-name]").value);
			formData.append('csv', this.newfile);
			axios.post(window.location.pathname + '/' + this.currentId,
					formData,
					{
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					}
			).then(function () {
				location.reload();
			})
					.catch(function () {
					});
		},
		deleteTable(id) {
			this.currentId = id;
			let formData = new FormData();
			formData.append('id', this.currentId);
			formData.append('_method', 'DELETE');
			axios.post(window.location.pathname + '/' + this.currentId,
					formData
			).then(function () {
				location.reload();
			})
					.catch(function () {
					});
		},
		generateChart(id) {
			let vm = this;
			let set = this.charts[id];
			let colors = ['#b33636', '#b38136', '#9ab336', '#4fb336', '#36b368', '#36b3b3', '#3668b3', '#4f36b3', '#9a36b3', '#b33681'];


			$.each(set.data_sets, function (index, val) {
				val['borderColor'] = colors[index];
				val['fill'] = false;
				val['backgroundColor'] = colors;
				set.data_sets[index] = val;
			});

			let chartData = {
				labels: set.labels,
				datasets: set.data_sets,
			};
			let ChartOptions = {
				responsive: true,
				maintainAspectRatio: true,
			};
			var ctx = vm.$refs.graph.getContext('2d');
			var chart = new Chart(ctx, {
				type: 'line',
				data: chartData,
				options: ChartOptions
			});
			var ctx = vm.$refs.bar.getContext('2d');
			var chart = new Chart(ctx, {
				type: 'bar',
				data: chartData,
				options: ChartOptions
			});
			var ctx = vm.$refs.hbar.getContext('2d');
			var chart = new Chart(ctx, {
				type: 'horizontalBar',
				data: chartData,
				options: ChartOptions
			});
			var ctx = vm.$refs.pie.getContext('2d');
			let pieData = {
				labels: set.labels,
				datasets: [{
					data: set.data_sets[0]['data'],
					backgroundColor: colors,
				}],
			};
			var chart = new Chart(ctx, {
				type: 'pie',
				data: chartData,
				options: ChartOptions
			});
		}
	}
}
</script>
